import Axios from 'axios';

class TransferDaysService {
  create(institutionId, days) {
    return Axios.post('/admin/transfer-days', {
      days,
      institution_id: institutionId,
    })
      .then(({ data }) => data);
  }

  get(institutionId) {
    return Axios.get('/admin/transfer-days', {
      params: {
        institution_id: institutionId,
      },
    })
      .then(({ data }) => data);
  }
}

export default new TransferDaysService();
